export default "__VITE_ASSET__B3jp6fep__"